import {FabricArt} from '~/common/fabric/types';

export type RecipientMessages = Record<string, string>;

export enum CardType {
  CARD = 'card',
  GIFTCARD = 'gift_card',
}

export enum EventStatus {
  NEW = 'new',
  CANCELED = 'cancelled',
  SCHEDULED = 'scheduled',
  SENDING = 'sending',
  CREATED = 'created',
  DRAFT = 'draft',
  VIDEOPROC = 'videoproc', // host wants to send, but video transcoding is still ongoing
  BLOCKED = 'blocked_host',
  PENDING = 'pending',
  FAILED = 'failed',
}

export type EcardAnalytics = {
  tracking_data?: object;
  tracking_product_type: string;
};

export type EcardSenderData = {
  host_id: string;
  previously_purchased_offer?: boolean;
};

export type EventOptionsDesign = {
  background: string | null;
  background_image_desktop: string | null;
  background_image_mobile: string | null;
  overlay_id: string | null;
  overlay_video_mobile_vp9: string | null;
  overlay_video_desktop_vp9: string | null;
  overlay_video_mobile_h265: string | null;
  overlay_video_desktop_h265: string | null;
  reveal_id: string | null;
  reveal_video_mobile_vp9: string | null;
  reveal_video_desktop_vp9: string | null;
  reveal_video_mobile_h265: string | null;
  reveal_video_desktop_h265: string | null;
};

export type EventOptionsWrite = {
  text_layer_back: string | null;
};

export type EventOptions = {
  design: EventOptionsDesign;
  write: EventOptionsWrite;
};

export type EcardTemplateData = {
  title: string;
  template_name: string;
};

export type EcardEventData = {
  event_host_name: string;
  event_type: string;
  known_timezone_name: string;
  used_as: CardType;
  shortlink?: string;
  status: EventStatus;
  send_count?: number;
  send_on?: string | null;
  sent_on?: string | null;
  start?: string;
  max_guest_list?: number;
  options: EventOptions;
  fabric_design_data?: FabricArt;
  system_generated: boolean;
  user_saved: boolean;
  gift_card_data: EcardGiftCardData;
};

export type Ecard = {
  id: string;
  event_data: EcardEventData;
  template_data: EcardTemplateData;
  sender_data: EcardSenderData;
  analytics: EcardAnalytics;
  is_ecard: boolean;
};
// TODO: this is the domain Event model, we should create the whole type based on it if want to be more precise
export type WindowEviteEvent = Omit<EcardEventData, 'event_host_name'> &
  EcardSenderData &
  EcardTemplateData & {
    id: string;
    host_name: string;
    tracking_data?: object;
    host_ids?: string[];
  };

export type AssetMedia = {label: string; url: string};
export type Asset = {
  id: string;
  display_name: string;
  keywords: string[];
  visible: boolean;
  media: AssetMedia[];
  primary_categories: string[];
  asset_groups: string[];
  brand: string | null;
};

export type Envelope = {
  id: string;
  name: null;
  display_name: string;
  image: string;
  icon: string;
  flap_down_image: string;
  text_color: string;
  blank: string;
  stamps: string[] | null;
  visible: boolean;
  liners: string[] | null;
  liner: string | null;
  stamp: string | null;
};

export type Assets = {
  backgrounds: Asset[];
  envelopes: Envelope[];
  liners: Asset[];
  overlays: Asset[];
  reveals: Asset[];
  stamps: Asset[];
  stickers: Asset[];
};

export type GetAssetsRequestParams = {
  assetGroups: string[];
  primaryCategories: string[];
  templateId: string;
};

export type FlipBehavior = 'disable' | 'force' | 'auto';
